import type { Action, Thunk } from 'easy-peasy';
import { action, thunk } from 'easy-peasy';
import type { StoreModel } from '..';
import { convertToZipZoneMappings } from '../../pages/AdminPages/ZipZoneMappings/util';
import type { Injections } from '../services/injections';
import type { CarrierZoneEntries, ZipZoneMapping } from '../services/ZipZoneService/types';

export interface FetchZipZonePayload {
  carrier: string;
  zoneKeyType: string;
  fromCountryCode: string;
  carrierIds: string[];
}

export interface ZipZoneModel {
  zipZoneMappings: ZipZoneMapping[];
  isZipZoneMappingsLoading: boolean;
  fetchZipZoneMappings: Thunk<ZipZoneModel, FetchZipZonePayload, Injections, StoreModel, Promise<ZipZoneMapping[]>>;
  setZipZoneMappings: Action<ZipZoneModel, ZipZoneMapping[]>;
  setIsZipZoneMappingsLoading: Action<ZipZoneModel, boolean>;
}

export const zipZoneModel: ZipZoneModel = {
  zipZoneMappings: [],
  isZipZoneMappingsLoading: false,
  fetchZipZoneMappings: thunk(async (actions, payload, { injections }) => {
    try {
      //default to first carrier if none is passed
      const formattedPayload = {
        ...payload,
        carrier: payload.carrier === '' ? payload.carrierIds[0] : payload.carrier,
      };
      const { carrier, zoneKeyType, fromCountryCode } = formattedPayload;
      actions.setIsZipZoneMappingsLoading(true);
      const { zipZoneService } = injections;
      const response: CarrierZoneEntries = await zipZoneService.fetchZipZoneMappings(
        carrier,
        zoneKeyType,
        fromCountryCode,
      );
      const mappings: ZipZoneMapping[] = convertToZipZoneMappings(zoneKeyType, response);
      actions.setZipZoneMappings(mappings);
      actions.setIsZipZoneMappingsLoading(false);
      return mappings;
    } catch (error) {
      actions.setIsZipZoneMappingsLoading(false);
      console.log(error);
      throw error;
    }
  }),
  setZipZoneMappings: action((state, zipZonesMappings) => {
    state.zipZoneMappings = zipZonesMappings;
  }),
  setIsZipZoneMappingsLoading: action((state, isLoading) => {
    state.isZipZoneMappingsLoading = isLoading;
  }),
};
